var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-layout"},[_c('WebsiteHeader'),_c('WebsiteContainer'),_c('WebsiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }